import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    backgroundColor: theme.colors.page__background_primary,
    overflow: 'hidden'
  },
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: theme.spacing(6, 8),
    borderRadius: theme.sizes.roundCorners
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  coverageContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  coverageLabel: {
    marginBottom: theme.spacing(2)
  },
  errorMessage: {
    color: theme.colorPalette.red_50,
    marginTop: theme.spacing(1)
  }
});

export default makeStyles(styles);
